import './style.scss'
import { useEffect, useState } from 'react'
import { AppLabel, AppText, CustomContainer, FlexRow, GridContainer, Input } from 'src/style'
import { FiSearch } from 'react-icons/fi'
import { HiOutlineChevronDown } from 'react-icons/hi'
import { BsFilter } from 'react-icons/bs'
import helpers from 'src/utils/helpers'
import { MdDateRange } from 'react-icons/md'


export const AppTable: React.FC<any> = ({
    data, columns, onRowClick, rowClass, titleClass, 
    tableClass, hasStripe, rowHeight, canFilter, canSearch,
    canDateSearch, flexSwitch
}) => {

    const [mockTableData, setMockTableData] = useState<any[]>([])
    const [date, setDate] = useState('1999-00-00')

    useEffect(() => {
        setMockTableData(data)
    }, [data])

    function handleDataSearching (e: React.ChangeEvent<HTMLInputElement>) {
        const filteredData = helpers.searchTableData(data, e.target.value)
        console.log({filteredData})
        setMockTableData(filteredData)
    }
    
    function handleRowClick(rowData: any) {
        if (onRowClick) onRowClick(rowData)
        return null
    }

    return (
        <CustomContainer className='customer-info-view-nav-wrap'>
            { (canFilter || canSearch || canDateSearch) &&
                <FlexRow bottomMargin="3" gap='2' justifyContent='space-between' className={flexSwitch ? 'table-search-filter-wrapper' : ''}>
                    { canSearch &&
                        <CustomContainer 
                            width='30' radius='0.4' borderColor='#E2E8F0' 
                            leftPadding='1.5' rightPadding='1.5'
                            bgColor='#ffffff' rightMargin='1.5'
                        >
                            <FlexRow>
                                <FiSearch style={{fontSize: '2rem', color: '#A0AEC0'}} />
                                <Input 
                                    height='4' leftPadding='1' placeholder='Search' color='#718096' 
                                    onChange={handleDataSearching} 
                                />
                            </FlexRow>
                        </CustomContainer>
                    }
                    { (canDateSearch || canFilter) &&
                        <FlexRow width='auto' sizeUnit='' className={flexSwitch ? 'table-filter-wrapper' : ''}>
                            { canDateSearch &&
                                <CustomContainer 
                                    width='22.6' radius='0.4' borderColor='#E2E8F0' 
                                    leftPadding='1' rightPadding='1'
                                    bgColor='#ffffff' leftMargin='1.5'
                                >
                                    <FlexRow height='4' justifyContent='space-between'>
                                        <input 
                                            className='date-input-hack' id='date' 
                                            type='date' 
                                            onChange={(e) => setDate(e.target.value)} 
                                            autoComplete="off"
                                        />
                                        <MdDateRange style={{fontSize: '2rem', color: '#4C6FFF'}} />
                                        <AppLabel 
                                            textSize='1.2' color='#718096' leftPadding='1' 
                                            topPadding='0.7' htmlFor='date'
                                        >
                                            {date}
                                        </AppLabel>
                                        <HiOutlineChevronDown style={{fontSize: '2rem', color: '#A0AEC0'}} />
                                    </FlexRow>
                                </CustomContainer>
                            }
                            { canFilter &&
                                <GridContainer
                                    width='8' height='4' radius='0.4' borderColor='#E2E8F0'
                                    rightPadding='1' leftPadding='1' leftMargin='1'
                                >
                                    <FlexRow>
                                        <BsFilter style={{fontSize: '2rem'}} />
                                        <AppText textSize='1.2' color='#718096' leftPadding='1'>Filter</AppText>
                                    </FlexRow>
                                </GridContainer>
                            }
                        </FlexRow>
                    }
                </FlexRow>
            }
            { (mockTableData && mockTableData?.length > 0) ?
                <CustomContainer
                    overflow="auto"
                    style={{display: 'inline-block'}}
                    className={tableClass || ''}
                >
                    <CustomContainer className='table-container'>
                        <FlexRow 
                            gap='2' leftPadding='2'
                            minHeight='3.7' rightPadding='2' 
                            className={titleClass || 'table-row'}

                        >
                            { 
                                columns?.map((item: any, index: number) => {
                                    return (
                                        <AppText 
                                            width={item?.width || '17.2'} textSize="1" 
                                            fontWeight='600' color='#8492A6' 
                                            align={item?.textAlign || 'left'}
                                            key={`th${index}`}
                                            className='table-text'
                                        >
                                            {item.name}
                                        </AppText>
                                    )
                                })
                            }
                        </FlexRow>
                        {
                            mockTableData?.map((item: any, index: number) => {
                                const bgColor = index % 2 === 0 ? '#F7FAFC' : '#ffffff'
                                return (
                                    <FlexRow gap='2' 
                                        leftPadding='2' rightPadding='2' 
                                        minHeight={rowHeight ? '7.9' : '4.6'} borderColor='#E2E8F0' radius='0.2'
                                        bottomMargin='1' key={`tr${index}`}
                                        className={rowClass || 'table-row'}
                                        bgColor={hasStripe ? bgColor : '#ffffff'}
                                        onClick={() => handleRowClick(item)}
                                    >
                                        {
                                            columns?.map((column: any, columnIndex: number) => {
                                                if (!column?.jsx) {
                                                    return (
                                                        <AppText 
                                                            width={column?.width || '17.2'} textSize="1.2" 
                                                            align={column?.textAlign || 'left'}
                                                            key={`td${columnIndex}`}
                                                            className='table-text'
                                                        >
                                                            {item[column?.key]}
                                                        </AppText>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        <CustomContainer width='auto' sizeUnit='' key={`td${columnIndex}`}>
                                                            {column.jsx(item)}
                                                        </CustomContainer>
                                                    )
                                                }
                                            })
                                        }
                                    </FlexRow>
                                )
                            })
                        }
                    </CustomContainer>
                </CustomContainer>
                :
                <GridContainer
                    minHeight='10' borderColor='#E2E8F0' radius='0.3'
                >
                    <AppText fontWeight='600' textSize='1.8'>No Record Found</AppText>
                </GridContainer>
            }
            
        </CustomContainer>
    )
}